import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'brand' | 'accent' | 'success' | 'danger' | 'outline' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export type Variante = ButtonVariant;
export type Tamano = ButtonSize;

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  variante?: ButtonVariant;
  size?: ButtonSize;
  tamano?: ButtonSize;
  children: ReactNode;
}

export type BotonProps = ButtonProps;

const VARIANTS: Record<ButtonVariant, string> = {
  brand: 'bg-accent text-accent-fg border border-transparent hover:opacity-90 active:opacity-95',
  accent: 'bg-accent text-accent-fg border border-transparent hover:opacity-90 active:opacity-95',
  success: 'bg-success text-on-status border border-transparent hover:opacity-90 active:opacity-95',
  danger: 'bg-danger text-on-status border border-transparent hover:opacity-90 active:opacity-95',
  outline: 'bg-surface text-text border border-border hover:border-accent hover:bg-surface-3',
  ghost: 'bg-transparent text-muted border border-border hover:border-accent hover:text-accent',
};

const SIZES: Record<ButtonSize, string> = {
  sm: 'h-8 px-3 text-xs gap-1.5 rounded-lg',
  md: 'h-10 px-4 text-sm gap-2 rounded-xl',
  lg: 'h-[3.125rem] px-5 text-[0.9375rem] gap-3 rounded-xl',
};

export function Button({
  variant,
  variante,
  size,
  tamano,
  children,
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) {
  const resolvedVariant = variant ?? variante ?? 'brand';
  const resolvedSize = size ?? tamano ?? 'md';

  return (
    <button
      type={type}
      className={`inline-flex cursor-pointer items-center justify-center font-bold transition-colors select-none disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[resolvedVariant]} ${SIZES[resolvedSize]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}

export const Boton = Button;
export default Button;
